"use client";
import { useState } from "react";
function useOptimisticSelection(value, { isControlled, initial, equals = Object.is }) {
    const [optimisticValue, setOptimisticValue] = useState(initial);
    const [lastSeen, setLastSeen] = useState(initial);
    const propChanged = isControlled && !equals(value, lastSeen);
    if (propChanged) {
        setLastSeen(value);
        setOptimisticValue(value);
    }
    return [
        propChanged ? value : optimisticValue,
        setOptimisticValue
    ];
}
export { useOptimisticSelection };
